import { useMemo } from "react";

import {
  BaseCellData,
  ColumnHeader,
} from "@/pages/EditSubjectPlan/types/types";

import { getFormattedCellKey } from "@/utils/getFormattedCellKey/getFormattedCellKey";

/**
 * Returns a set of row/column pairs that need to be skipped as a cell is spanning over them
 */
export const useSkipCells = <T extends BaseCellData>(
  cells: T[],
  columns: ColumnHeader[]
) => {
  // we need a set of row/column pairs what need to be skipped as a cell is spanning over them
  const skipSpannedCells = useMemo(() => {
    const skipSpannedCells = new Set<string>();

    cells.forEach((cell) => {
      // if the cell has a span and it's larger than 1, we need the sebsequent cells to the skip list that match the span
      if (cell.span && cell.span > 1) {
        const column = columns.find((column) => column.id === cell.column);
        const columnIndex = column ? columns.indexOf(column) : null;

        if (columnIndex === null) {
          return;
        }

        // for each cell that is spanned, we need to add it to the skip list
        for (let i = 1; i < cell.span; i++) {
          const nextColumn = columns[columnIndex + i];

          const formattedCellKey = getFormattedCellKey({
            row: cell.row,
            column: nextColumn.id,
          });

          skipSpannedCells.add(formattedCellKey);
        }
      }
    });

    return skipSpannedCells;
  }, [cells, columns]);

  return { skipSpannedCells };
};
